import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editCategory: [],
  loading: false,
  error: null,
};

const editCategorySlice = createSlice({
  name: "editCategory",
  initialState,
  reducers: {
    fetchEditCategorySuccess: (state, action) => {
      state.loading = false;
      state.editCategory = action.payload;
    },
    fetchEditCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchEditCategorySuccess,
  fetchEditCategoryFailure,
} = editCategorySlice.actions;

export default editCategorySlice.reducer;